import { TableMenuActionEnums } from '@/enums/TableMenuActionEnums';

export interface ITableMenuItem {
    textId: string;
    icon: string;
    action: TableMenuActionEnums;
    disabled?: boolean;
}

export class TableMenuItem implements ITableMenuItem {
    public textId: string;
    public icon: string;
    public action: TableMenuActionEnums;
    public disabled?: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableMenuItem);
    constructor(obj?: any) {
        this.textId = obj && obj.textId || '';
        this.icon = obj && obj.icon || 'mdi-plus';
        this.action = TableMenuActionEnums.UNKNOWN;
        if (obj && obj.action != null) {
            this.action = obj.action || TableMenuActionEnums.UNKNOWN;
        }
        this.disabled = obj && obj.disabled ? obj.disabled : false;
    }
}
